<template>
    <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
        <div class="dev-list">
            <div class="search-btn">
                <div class="search-btn-pre">
                    <!--<el-button size="small" type="primary" @click="scanCaseNode"  v-if="$store.getters.checkChangeAuth()">扫描分层处理器</el-button>-->
                    <el-button size="small" type="primary" :disabled="multipleSelection.length === 0"
                               @click="rebootDevBatch" v-if="$store.getters.checkChangeAuth()">重启
                    </el-button>
                    <el-button size="small" type="primary" :disabled="multipleSelection.length === 0"
                               @click="deleteDevBatch" v-if="$store.getters.checkChangeAuth()">删除
                    </el-button>
                </div>
            </div>
            <div class="device-case-dev border-all">
                <el-table ref="multipleTable" :height="tableHeight" :data="info.list"
                          :header-cell-style="{backgroundColor: '#efefef'}" @row-click="checkRow" size="mini"
                          tooltip-effect="dark" style="width: 99%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" align="center" header-align="center"
                                     :selectable="isCommonCard"></el-table-column>
                    <el-table-column prop="id" label="ID" min-width="50px">
                        <template slot-scope="scope">
                            {{scope.row.cardType === 1 ? scope.row.id : "分层"}}
                        </template>
                    </el-table-column>
                    <el-table-column label="槽位号">
                        <template slot-scope="scope">
                            <div class="card-pos">
                                <span style="width:30px;text-align: left">{{scope.row.slotNo}}</span>
                                <el-button type="text" size="small" slot="reference" :disabled="true"
                                           v-if="scope.row.isContainer == 1"
                                           @click.stop="showCasePos(scope.row)"><img
                                        style="width:20px; height: 20px;" src="../assets/magnifier_gray.png"/>
                                </el-button>
                                <el-button type="text" size="small" slot="reference" v-else
                                           @click.stop="showCasePos(scope.row)"><img
                                        style="width:20px; height: 20px;" src="../assets/magnifier.png"/>
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceIp" label="设备IP"></el-table-column>
                    <el-table-column prop="deviceNo" label="设备编号"></el-table-column>
                    <el-table-column prop="version" label="设备版本" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="softinstalled" label="应用安装数量"></el-table-column>
                    <el-table-column label="状态" width="130px">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" placement="top"
                                        v-if="$store.state.licenseInfo.hasOwnProperty('isNew') && $store.state.licenseInfo.isNew == 1 && scope.row.deviceUuid.length > 0 && scope.row.isAuth !== 1">
                                <span slot="content">{{showDeviceToolTip(scope.row)}}</span>
                                <span :style="scope.row | statusClassFilter">
            {{scope.row | statusStr}}
                                <span :style="scope.row | authStatusClassFilter">
            {{scope.row | authStatusStr}}
          </span>
          </span>
                            </el-tooltip>
                            <span :style="scope.row | statusClassFilter" v-else>
            {{scope.row | statusStr}}
          </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="groupName" label="分组"></el-table-column>
                    <el-table-column prop="disk" label="剩余空间">
                        <template slot-scope="scope">
                            {{ scope.row.disk + '%' }}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="120px" label="操作">
                        <template slot-scope="scope">
                            <!--<el-button type="text" size="small" :disabled="scope.row.isDistributed === 0" @click="recoverDev(scope.row.deviceIp)">回收</el-button>-->
                            <el-button type="text" size="small" :disabled="scope.row.deviceStatus !== 0"
                                       @click.stop="initDev(scope.row.deviceIp)"
                                       v-if="$store.getters.checkChangeAuth() && scope.row.cardType !== 2">恢复出厂
                            </el-button>
                            <el-button type="text" size="small" slot="reference"
                                       @click.stop="groupDevPop(scope.row.deviceIp)"
                                       v-if="$store.getters.checkChangeAuth() && scope.row.cardType !== 2">分组
                            </el-button>
                            <el-button type="text" size="small" :disabled="scope.row.deviceStatus !== 0"
                                       slot="reference"
                                       @click.stop="deviceWindowOpen(scope.row.id, scope.row.deviceNo, scope.row.deviceIp, scope.row.engineType)"
                                       v-if="$store.getters.checkChangeAuth() && scope.row.cardType !== 2">控制
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="list-bottom">
                    <div class="list-bottom-btn">

                    </div>
                    <el-pagination
                            @size-change="sizeChangeHandle"
                            @current-change="currentChangeHandle"
                            :current-page="page.startPage"
                            :page-sizes="[10, 20, 50]"
                            :page-size="page.limit"
                            :pager-count="5"
                            layout="total, sizes, prev, pager, next"
                            :total="info.total">
                    </el-pagination>
                </div>
                <Drawer title="设备分组" :visible.sync="groupDevPopShow" @handClick="groupDev">
                    <!--<el-dialog title="设备分组" :append-to-body="true" :visible.sync="groupDevPopShow"  width="500px" top="15vh">-->
                    <el-select v-model="groupInfo.groupId" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </Drawer>
            </div>
        </div>
        <DeviceCase3D ref="case3d" v-if="casePosShow">

        </DeviceCase3D>
    </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import DeviceCase3D from '@/components/DeviceCase3D'
    export default {
        name: "DeviceCaseDev",
        components: {Drawer, DeviceCase3D},
        data() {
            return {
                tableHeight: 0,
                info: {
                    success: false,
                    caseList: [],
                    total: 0
                },
                page: { // 分页参数
                    startPage: 1,
                    limit: 10,
                    caseNo: this.$store.state.caseInfo.caseNo
                },
                multipleSelection: [], // 选中的对象列表
                groupDevPopShow: false, // 是否显示分组弹窗
                formLabelWidth: '120px',
                groupInfo: {
                    groupId: '',
                    deviceIp: ''
                },
                options: [],
                timeoutId: 0,
                casePosShow: false
            }
        },
        methods: {
            showCasePos(row) {
                if (this.$refs.case3d) {
                    this.$refs.case3d.showCasePos(row)
                }
            },
            hideAllPopShow() {
                if (this.$refs.case3d) {
                    this.$refs.case3d.hideAllPopShow()
                }
            },
            showDeviceToolTip(row) {
                // console.log("row is " + JSON.stringify(row))
                if (row.deviceUuid.length > 0 && row.isAuth === 0) {
                    return "该设备未通过认证，请联系运维人员"
                } else if (row.deviceUuid.length > 0 && row.isAuth === 2) {
                    return "该设备认证过期，请联系运维人员"
                } else {
                    return "该设备已认证"
                }
            },
            /* 表单击行事件 */
            checkRow(r, c, e) {
                if (r.cardType === 1) this.$refs.multipleTable.toggleRowSelection(r)
            },
            /* 获取设备列表 */
            getDeviceList() {
                let that = this
                that.$post(that.$uri.device.deviceList, that.page).then(res => {
                    that.info = res
                })
            },
            /* 获取设备列表 */
            getDeviceList2Refresh() {
                let that = this
                that.$post(that.$uri.device.deviceList, that.page).then(res => {
                    this.info.list.forEach(v => {
                        res.list.forEach(i => {
                            if (v.id === i.id) {
                                v.deviceStatus = i.deviceStatus
                            }
                        })
                    })
                })
            },
            /* 推流 */
            /*
            h5Test (deviceNo) {
              console.log("aasdasfas")
              let tempwindow = window.open()
              tempwindow.location = this.$store.getters.h5TestUrl(deviceNo)
            },
            */
            deviceWindowOpen(id, deviceNo, ip, engineType) {
                if (this.$store.state.deviceWindowMode.length > 0) {
                    this.$message.error("同时只能控制一台设备！")
                } else {
                    this.$store.commit(this.$mutation.DEVICE_WINDOW_SHOW_MODE, {
                        show: true,
                        mode: {
                            show: true,
                            id,
                            deviceNo,
                            ip: ip,
                            engineType
                        }
                    });
                }
            },
            isCommonCard(row, index) {
                // return row.cardType === 1
                return true
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getDeviceList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getDeviceList()
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
            /* 删除设备 */
            async deleteDev(deviceIp) {
                let that = this
                await that.$post(that.$uri.device.deviceDelete, {deviceIp})
            },
            /* 批量删除设备 */
            deleteDevBatch() {
                this.$confirm("删除设备会导致设备恢复出厂设置，清除数据，是否继续？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-red',
                    iconClass: 'el-icon-c-red',
                    cancelButtonText: '取消'
                }).then(() => {
                    let deviceIps = []
                    this.multipleSelection.forEach(v => {
                        deviceIps.push(v.deviceIp)
                    })
                    let that = this
                    that.$post(that.$uri.device.deviceDelete, {deviceIps}).then(res => {
                        this.$message.success("删除完成")
                        this.getDeviceList()
                    })
                }).catch(() => {
                })
            },
            /* 设备重启 */
            async rebootDev(deviceIp) {
                let that = this
                await that.$post(that.$uri.device.deviceReboot, {deviceIp})
            },
            /* 设备批量重启 */
            rebootDevBatch() {
                this.$confirm("重启设备会导致当前应用缓存丢失，是否继续？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-yellow',
                    iconClass: 'el-icon-c-yellow',
                    cancelButtonText: '取消'
                }).then(() => {
                    let deviceIps = []
                    this.multipleSelection.forEach(v => {
                        deviceIps.push(v.deviceIp)
                    })
                    let that = this
                    that.$post(that.$uri.device.deviceReboot, {deviceIps}).then(res => {
                        this.$message.success("重启完成")
                        this.getDeviceList()
                    })
                }).catch(() => {
                })
            },
            /* 恢复出厂设置 */
            initDev(deviceIp) {
                this.$confirm("恢复出厂后设备的应用和数据都会被清除， 是否继续？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-red',
                    iconClass: 'el-icon-c-red',
                    cancelButtonText: '取消'
                }).then(() => {
                    let that = this
                    that.$post(that.$uri.device.deviceRestore, {deviceIp}).then(res => {
                        that.$message.success("恢复出厂设置成功")
                    })
                }).catch(() => {
                })
            },
            /* 设备回收 */
            recoverDev(deviceIp) {
                let that = this
                that.$post(that.$uri.device.deviceRecover, {deviceIp}).then(res => {
                    that.$message.success("回收成功")
                })
            },
            /* 获得分组信息 */
            getGroupList() {
                let that = this
                that.$post(that.$uri.group.list, {}).then(res => {
                    let options = []
                    res.list.forEach(v => {
                        options.push({
                            value: v.id,
                            label: v.groupName
                        })
                    })
                    this.options = options
                })
            },
            /* 设备分组 */
            groupDev() {
                let that = this
                that.$post(that.$uri.device.deviceGrouping, that.groupInfo).then(res => {
                    that.$message.success("分组成功")
                    this.groupDevPopShow = false
                    this.getDeviceList()
                })
            },
            /* 弹出分组弹框 */
            groupDevPop(deviceIp) {
                this.groupDevPopShow = true
                this.groupInfo.deviceIp = deviceIp
            },
            /* 10s刷新一次数据 */
            refreshDevList() {
                if (this.$route.meta.refresh) {
                    this.getDeviceList2Refresh()
                    setTimeout(() => {
                        this.refreshDevList()
                    }, 5000)
                }
            }
        },
        filters: {
            statusStr(row) {
                let status = ""
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    status = "推流中";
                } else if (row.deviceMirrorOperationStatus != null && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    // console.log("row is " + JSON.stringify(row))
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            status = "镜像准备中";
                            break
                        case 1:
                            status = "镜像保存中";
                            break
                        case 2:
                            status = "镜像保存失败";
                            break
                        case 3:
                            status = "镜像上传中";
                            break
                        case 4:
                            status = "镜像上传失败";
                            break
                        case 10:
                            status = "镜像下载中";
                            break
                        case 11:
                            status = "镜像下载失败";
                            break
                        case 12:
                            status = "镜像切换中";
                            break
                        case 13:
                            status = "镜像切换失败";
                            break
                        case 20:
                            status = '命令发送失败';
                            break;
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            status = "正常";
                            break
                        case 1:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "未更新"
                            }
                            break
                        case 2:
                            status = "应用安装中";
                            break
                        case 3:
                            if (row.onOff == 2) {
                                status = "已关机"
                            } else {
                                status = "故障";
                            }
                            break
                        case 4:
                            status = "预启动";
                            break
                        case 5:
                            status = "清理中";
                            break
                        case 6:
                            status = "升级中";
                            break
                        case 7:
                            status = "应用结束中";
                            break
                    }
                }

                return status;
            },
            authStatusStr(row) {
                let status = ""

                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    status = "<认证失败>"
                }
                return status;
            },

            statusClassFilter(row) {
                if (row.isFlow === 1 && row.deviceStatus === 0) {
                    return {color: "green"};
                } else if (row.deviceMirrorOperationStatus && row.deviceMirrorOperationStatus != 5 && row.deviceMirrorOperationStatus != 14) {
                    switch (row.deviceMirrorOperationStatus) {
                        case 0:
                            return {color: "green"};
                        case 1:
                            return {color: "green"};
                        case 2:
                            return {color: "red"};
                        case 3:
                            return {color: "green"};
                        case 4:
                            return {color: "red"};
                        case 10:
                            return {color: "green"};
                        case 11:
                            return {color: "red"};
                        case 12:
                            return {color: "green"};
                        case 13:
                            return {color: "red"};
                    }
                } else {
                    switch (row.deviceStatus) {
                        case 0:
                            return {color: "green"};
                        case 3:
                            return {color: "red"};
                        default:
                            return {color: "#eab820"};
                    }
                }
            },
            authStatusClassFilter(row) {
                if (row.deviceUuid.length > 0 && row.isAuth !== 1) {
                    return {
                        color: "#aaa",
                        maxWidth: "100px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    };
                }
            }
        },
        mounted() {
            this.getDeviceList()
            this.getGroupList()
            this.refreshDevList()
            this.$nextTick().then(() => {
                if (this.$refs.multipleTable) {
                    this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                    if (this.casePosShow == false) {
                        this.casePosShow = true
                    }
                }
            })
        }
    };
</script>

<style lang="less">
    .dev-list {
        z-index: 1;
        width: 100%;
        background-color: white;
        .device-case-dev {
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }
</style>
